import(/* webpackMode: "eager" */ "/vercel/path0/src/app/services/[Pages]/page.js")